module.exports = __webpack_public_path__ + "proex.jpg?0d7a51f7193b1a36e55b27835f7bf40b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/proex.jpg
// module id = 148
// module chunks = 0